module.exports = __webpack_public_path__ + "static/media/image_24.3241ada7.png";